import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable, of, throwError } from 'rxjs';

import { catchError, map } from 'rxjs/operators';

import { Discount, UpsertDiscountResponse } from '../models/settings.model';

@Injectable({
  providedIn: 'root',
})
export class DiscountService {
  private baseUrl = `${this.env.API_BASE_URL}/service/pig-registration/secure/discount/`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: { API_BASE_URL: string },
  ) {}

  upsertDiscount(discount: Discount): Observable<UpsertDiscountResponse> {
    return this.http.post<UpsertDiscountResponse>(this.baseUrl, discount, {});
  }

  getDiscount(): Observable<Discount | HttpErrorResponse> {
    return this.http.get<Discount>(this.baseUrl).pipe(
      map((discount: Discount) => discount),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Discount>{});
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }
}
